import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from "../../../../common/variables/translate-service";
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ImportPlanComponent } from "../import-plan/import-plan.component";
import { GlobalVariableService } from "../../../../common/variables/global-variable";

@Component({
  selector: 'sen-app-import-plan-button',
  templateUrl: './import-plan-button.component.html',
  styleUrls: ['./import-plan-button.component.scss']
})
export class ImportPlanButtonComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() selectedProjectRoofPlan: any[];
  constructor(
    public global: GlobalVariableService,
    public dialog: MatDialog,
    public translate: TranslateService,
  ) { }

  ngOnInit(): void {
  }
  //import box

  importPlans() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `${this.translate.getLng('IMPORT_BUTTON')} ${this.translate.getLng('PLAN')}`,
      options: {
        plan: this.translate.getLng('PLAN'),
        project: this.translate.getLng('PROJECT')
      },
      buttons: {
        import: this.translate.getLng('IMPORT_BUTTON'),
        cancel: this.translate.getLng('CANCEL')
      },
      roofPlans: this.selectedProjectRoofPlan ? this.selectedProjectRoofPlan : []
    };
    dialogConfig.disableClose = true;
    dialogConfig.width = '400px';
    dialogConfig.position = { top: '10vh' }
    let dialogRef = this.dialog.open(ImportPlanComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result: boolean) => {
      dialogRef.close();
      if (result) {
        // this.router.navigate([this.loginPath])
      }
    });
  }
}
